import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/payment',
	components: () => [import('./component')],
	render: ([Payment]) => <Payment />,
	onEnter: async ({ store, history }) => {
		console.log('on Enter Payment');

		const { login } = store.getState();
		const [isExpired, isNotGrMember] = [login.isGrMember.expired, !login.isGrMember.isMember];

		// token 過期 or 非會員 皆無法進入會員頁
		if (isExpired || isNotGrMember) {
			history.replace('/');
		}
		console.log('on Enter Payment / end');
	},
};

export default routes;
